App.namespace.wrap('es6.views.messenger.enquiry_share_details', function (options = {}) {
  const RegexManager = App.shared.RegexManager;

  const $textarea = options.textarea;
  const $container = options.container || $textarea.parent();

  const {
    $popup = $container.find('.js-messenger-contact-popup-wrap'),
    $popupContent = $container.find('.js-messenger-contact-popup'),
    $close = $container.find('.js-messenger-contact-close'),
    $mailAndPhone = $container.find('.js-messenger-contact-mail-and-phone'),
    $readMore = $container.find('.js-messenger-contact-full'),
    $readMoreButton = $container.find('.js-messenger-readmore'),
    $checkbox = $container.find('.js-messenger-contact-checkbox'),
  } = options;

  const MUTE_TOOTLIP_DURATION = 1000 * 3600 * 24 * 30;
  const LOCAL_STORAGE_KEY_MAIL = 'enquiry_shared_details_mail';
  const MAX_TOP_HEIGHT = 300; // breakpoint when tooltip goes below

  let visibleTooltip = null; // phone or mail

  let ignoredTooltips = {
    mail: false,
  };
  function show (el, tooltipType) {
    if (tooltipType) {
      visibleTooltip = tooltipType;

      if (tooltipType === 'mail') {
        $popupContent.addClass('js-messenger-contact-popup--mail');
      } else {
        $popupContent.removeClass('js-messenger-contact-popup--mail');
      }
    }

    el.removeClass('hidden');
  }

  function hide (el) {
    el.addClass('hidden');
  }

  function hideAll () {
    [
      $popup,
      $mailAndPhone,
      $readMore,
    ].forEach(hide);

    visibleTooltip = null;
  }

  function updateTooltipPosition () {
    const fromTop = $textarea.offset().top;

    if (fromTop > MAX_TOP_HEIGHT) {
      $popup.removeClass('js-messenger-contact-popup-wrap--bottom');
      $popup.attr('style', '');
      return;
    }

    $popup.addClass('js-messenger-contact-popup-wrap--bottom');

    $popup.css({
      marginTop: $textarea.outerHeight()
    });
  }

  function onMessageType() {
    if (ignoredTooltips.mail) {
      return;
    }

    const val = $textarea.val();

    if ((RegexManager.containsEmail(val) || RegexManager.containsPhone(val)) && !ignoredTooltips.mail && !isMailTooltipMuted()) {
      show($popup);
      show($mailAndPhone, 'mail');
      hide($readMore);
    } else {
      hideAll();
    }

    updateTooltipPosition();
  }

  function readMore() {
    hide($mailAndPhone);
    show($readMore);
  }

  function isMailTooltipMuted() {
    if (!localStorage) {
      return false;
    }
    const now = (new Date()).getTime();

    const timePassedMail = now - (+(localStorage.getItem(LOCAL_STORAGE_KEY_MAIL) || 0));

    return localStorage && timePassedMail < MUTE_TOOTLIP_DURATION;
  }

  function areTooltipsMuted() {
    return isMailTooltipMuted();
  }

  function getActiveTooltipLSKey() {
    return {
      'mail': LOCAL_STORAGE_KEY_MAIL,
    }[visibleTooltip];
  }

  function saveToLocalStorage() {
    if (!localStorage) {
      return;
    }

    localStorage.setItem(getActiveTooltipLSKey(), (new Date()).getTime().toString());
  }

  function removeFromLocalStorage() {
    if (!localStorage) {
      return;
    }

    localStorage.removeItem(getActiveTooltipLSKey());
  }

  function checkboxChange() {
    if ($checkbox[0].checked) {
      saveToLocalStorage();
    } else {
      removeFromLocalStorage();
    }
  }

  function init() {
    if (areTooltipsMuted()) {
      return;
    }

    $textarea.on('keyup', onMessageType);
    $close.on('click', () => {
      ignoredTooltips[visibleTooltip] = true;
      $checkbox[0].checked = false;
      hideAll();
    });
    $readMoreButton.on('click', readMore);

    $(window).on('resize', updateTooltipPosition);
    $textarea.on('resize', updateTooltipPosition);
    $checkbox.on('change click', checkboxChange);

    $($textarea).on('mousemove', updateTooltipPosition);
    $('#pricing_method_select, #preview_quote, #type').on('change click', hideAll);
  }

  return {
    init,
  }
});
